// removed by extract-text-webpack-plugin
module.exports = {"logo":"style__logo___1tIe1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/logo/style.scss
// module id = 748
// module chunks = 51